{
	"b": "B:",
	"g": "G:",
	"pickTargetNeutral": "Pick a target neutral:",
	"r": "R:"
}
